import { render, staticRenderFns } from "./SuperVideo.vue?vue&type=template&id=cf295d08"
import script from "./SuperVideo.vue?vue&type=script&lang=js"
export * from "./SuperVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports